import { gql } from 'graphql-request';

import withFragments from 'utils/graphql';

import { RichTextBlock, ImageChooserBlock, NamedLinkBlock, CustomEmbedBlock } from 'fragments/GenericBlocks';
import FAQBlock from 'fragments/Faq';
import PopularActivities from 'fragments/PopularActivity';
import CTABlock from 'fragments/CTABlock';
import LatestNews from 'fragments/LatestNews';
import Contact from 'fragments/Contact';
import Logo from 'fragments/Logo';

export default withFragments(
  gql`
    query($id: Int, $contentType: String!, $token: String!, $hostname: String) {
      page(id: $id, contentType: $contentType, token: $token) {
        id
        url
        title
        slug
        seoTitle
        seoDescription
        ... on SimpleContentPage {
          subtitle
          metaImage {
            url
          }
          metaTitle
          metaDescription
          logo {
            ...Logo
          }
          breadcrumbs {
            title
            url
          }
          body {
            blockType
            id
            ...ImageChooserBlock
            ...RichTextBlock
            ...Faq
            ...PopularActivities
            ...CTABlock
            ...LatestNews
            ...Contact
            ...NamedLinkBlock
            ...CustomEmbedBlock
          }
        }
      }
    }
  `,
  {
    RichTextBlock,
    ImageChooserBlock,
    NamedLinkBlock,
    CustomEmbedBlock,
    FAQBlock,
    PopularActivities,
    CTABlock,
    LatestNews,
    Contact,
    Logo,
  },
);
